import { Grid, Card, CardContent } from "@mui/material";

import PersonaNatural from "./PersonaNatural";
import PersonDocument from "./PersonDocument";
import PersonContact from "./PersonContact";
import PersonDirection from "./PersonDirection";
import PersonBonding from "./PersonBonding";

const PersonNaturalFormBody = ({
    sliceKey,
    id,
    hideInputs = false,
    showBonding = true,
    isReadOnly = false
}) => {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Card>
                    <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                        <PersonaNatural
                            sliceKey={sliceKey}
                            hideInputs={hideInputs}
                            id={id}
                            autoFocus
                            isReadOnly={isReadOnly}
                        />
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={12} lg={6}>
                <Card>
                    <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                        <PersonDocument sliceKey={sliceKey} id={id} isReadOnly={isReadOnly} />
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={12} lg={6}>
                <Card>
                    <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                        <PersonContact sliceKey={sliceKey} id={id} isReadOnly={isReadOnly} />
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={12}>
                <Card>
                    <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                        <PersonDirection sliceKey={sliceKey} id={id} isReadOnly={isReadOnly} />
                    </CardContent>
                </Card>
            </Grid>

            {showBonding && (
                <Grid item xs={12} lg={6}>
                    <Card>
                        <CardContent sx={{ padding: "0px 10px 10px !important" }}>
                            <PersonBonding sliceKey={sliceKey} id={id} isReadOnly={isReadOnly} />
                        </CardContent>
                    </Card>
                </Grid>
            )}
        </Grid>
    );
};

export default PersonNaturalFormBody;
